import ResponsiveDialog from 'app/components/dialog/ResponsiveDialog'
import { makeStyles } from '@material-ui/core/styles'
import React from 'react'
import { DialogContent, DialogTitle, Icon, Grid } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'

const useStyles = makeStyles(() => ({
  container: {
    color: 'rgba(0,0,0,0.54) !important',
  },
}))
const PlanBillingTermAndConditionBeacon = (props) => {
  const classes = useStyles()
  const { isOpen, onClose } = props
  return (
    <ResponsiveDialog
      isFullScreen={false}
      open={isOpen}
      onClose={onClose}
      scroll="paper"
      aria-labelledby="scroll-dialog-title"
      classes={{ paper: 'm-24' }}
    >
      <DialogTitle id="scroll-dialog-title">
        <Grid container spacing={2}>
          <Grid item xs={11}>
            <FormattedMessage id="planAndBilling.yourPlan.changePlan.plan.starterPack.info.termAndConditions" />
          </Grid>
          <Grid item xs={1} className="cursor-pointer">
            <Icon className="text-22" color="action" onClick={onClose}>
              close
            </Icon>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent className={classes.container}>
        <h2>
          <span className="font-400 text-blue-primary">1. ORDERING</span>
        </h2>
        <p>
          <span className="font-400">
            Customer(s) may place an order for NotifyMe Beacon packages on the
            NotifyMe website &ldquo;www.ifyoucan.com&rdquo;
            (&ldquo;Website&rdquo;). Each Order is complete when NotifyMe ships
            the Products.{' '}
          </span>
          <strong>
            CUSTOMER AGREES THAT ANY TERMS AND CONDITIONS INCONSISTENT WITH OR
            IN ADDITION TO THE TERMS AND CONDITIONS SET FORTH IN THIS AGREEMENT,
            INCLUDING WITHOUT LIMITATION ANY PURCHASE ORDER TERMS AND CONDITIONS
            PURPORTED TO BE IMPOSED BY CUSTOMER, ARE REJECTED AND NULL AND OF NO
            EFFECT, EVEN IF NOTIFYME ACCEPTS, ACKNOWLEDGES OR SHIPS PRODUCTS IN
            RESPONSE TO A CUSTOMER PURCHASE ORDER.
          </strong>
        </p>
        <h2 className="mt-16">
          <span className="font-400 text-blue-primary">2. PAYMENT</span>
        </h2>
        <p>
          <span className="font-400">
            Customer(s) may pay for an Order either by credit card or by wire
            transfer. If Customer(s) elects to pay by credit card, (i) Customer
            will submit credit card payment details at the time an Order is
            placed through the Website and (ii) Customer&rsquo;s credit card
            will be charged for the Products and for shipping at the time of
            shipment of the Order. If Customer elects to pay by wire transfer,
            (i) Customer will provide invoice instructions to NotifyMe at the
            time an Order is placed through the Website, (ii) NotifyMe will
            invoice Customer for the Products and for shipping upon receipt of
            the Order, and (iii) Customer will pay NotifyMe by wire transfer
            within thirty (30) days of receipt of the invoice for such Order
            unless other payment terms are agreed upon in writing by NotifyMe
            and Customer prior to shipment.
          </span>
        </p>
        <h2 className="mt-16">
          <span className="font-400 text-blue-primary">3. SHIPMENT</span>
        </h2>
        <p>
          <span className="font-400">
            NotifyMe will ship an Order upon either (i) successful processing of
            a credit card payment for such Order or (ii) receipt of a wire
            transfer payment for such Order. NotifyME may, however, at its sole
            discretion, ship an Order prior to receipt of payment for an Order.
            Title to the Beacons and risk of loss will pass to Customer upon
            delivery to the carrier at the point of origin. For shipments
            outside Thailand, Customer(s) are responsible for clearing the goods
            for import and paying all formalities, duties, taxes, and other
            charges upon import. Scheduled shipment dates, if any, are estimates
            only, and NotifyMe is not liable for any loss or damage or penalty
            resulting from delay.
          </span>
        </p>
        <h2 className="mt-16">
          <span className="font-400 text-blue-primary">
            4. ACCEPTANCE OF PRODUCTS
          </span>
        </h2>
        <p>
          <span className="font-400">
            If the Products shipped by NotifyMe do not function to
            Customer&rsquo;s satisfaction, Customer may contact NotifyMe via
            e-mail at{' '}
          </span>
          <span className="font-400">&ldquo;EMAIL&rdquo; </span>
          <span className="font-400">
            within thirty (30) days of delivery of an Order to arrange for
            either (i) replacement of the Product by NotifyMe within a
            commercially reasonable time period or (ii) a refund of the Beacon
            Package less shipping costs. If Customer requests a refund, NotifyMe
            may send Customer a prepaid return shipping label in which case
            Customer agrees to return the Products in order to receive the
            refund. If Customer(s) does not contact NotifyMe within thirty (30)
            days of delivery of an Order, the Products delivered shall be deemed
            accepted by Customer.
          </span>
        </p>
        <h2 className="mt-16">
          <span className="font-400 text-blue-primary">
            6. INTELLECTUAL PROPERTY
          </span>
        </h2>
        <p>
          <span className="font-400">
            All intellectual property rights in and to the Products, including
            all patent rights, copyrights, trademarks, trade secrets or other
            proprietary rights therein shall be and remain the sole property of
            NotifyME.
          </span>
        </p>
        <h2 className="mt-16">
          <span className="font-400 text-blue-primary">
            7. WARRANTY DISCLAIMER
          </span>
        </h2>
        <p>
          <span className="font-400">
            NOTIFYME DOES NOT MAKE, AND HEREBY EXPRESSLY DISCLAIMS, ANY WARRANTY
            OR REPRESENTATION WITH RESPECT TO THE PRODUCTS OR SERVICES, EXPRESS
            OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
            MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, PERFORMANCE,
            ACCURACY, RELIABILITY, AND NON‐INFRINGEMENT. NOTIFYME DOES NOT
            WARRANT THAT THE OPERATION OF THE PRODUCTS WILL BE UNINTERRUPTED OR
            ERROR FREE OR THAT THE PRODUCTS WILL MEET CUSTOMER&rsquo;S OR ANY
            THIRD PARTY&rsquo;S EXPECTATIONS.
          </span>
        </p>
        <h2 className="mt-16">
          <span className="font-400 text-blue-primary">
            8. LIMITATION OF LIABILITY
          </span>
        </h2>
        <p>
          <span className="font-400">
            WHETHER UNDER ANY WARRANTY, CONTRACT, TORT, NEGLIGENCE OR OTHER
            LEGAL OR EQUITABLE THEORY, THE FOLLOWING WILL APPLY TO NOTIFYME AND
            ITS AFFILIATES AND ALL PRODUCTS, INCLUDING SOFTWARE, AND SERVICES OF
            ESTIMOTE IN ALL CIRCUMSTANCES (EXCEPT WITH RESPECT TO BODILY INJURY
            OR DEATH OF A PERSON): (A) NOTIFYME WILL NOT BE RESPONSIBLE OR
            LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, PUNITIVE OR
            CONSEQUENTIAL DAMAGES INCLUDING, BUT NOT LIMITED TO, LOSS OF
            REVENUES, LOSS OF PROFITS OR LOSS OR INACCURACY OF DATA; AND (B)
            NOTIFYME&rsquo;S CUMULATIVE LIABILITY FOR ANY AND ALL DAMAGES IS
            LIMITED TO AMOUNTS PAID TO NOTIFYME BY CUSTOMER FOR THE PARTICULAR
            PRODUCTS AND/OR SERVICES WITH RESPECT TO WHICH A CLAIM IS MADE.
            NOTIFYME HAS AGREED WITH CUSTOMER THAT THESE LIMITATIONS WILL
            SURVIVE AND APPLY EVEN IF ANY LIMITED REMEDY SPECIFIED IN THIS
            AGREEMENT IS FOUND TO HAVE FAILED OF ITS ESSENTIAL PURPOSE. SOME
            JURISDICTIONS DO NOT ALLOW THE EXCLUSION OR LIMITATION OF INCIDENTAL
            OR CONSEQUENTIAL DAMAGES, SO THE ABOVE LIMITATION AND EXCLUSION MAY
            NOT APPLY TO CUSTOMER.
          </span>
        </p>
        <h2 className="mt-16">
          <span className="font-400 text-blue-primary">
            9. ARBITRATION/CHOICE OF LAW/VENUE
          </span>
        </h2>
        <p>
          <span className="font-400">
            Any dispute which arises out of, relates to or concerns this
            Agreement (other than those arising under Section 7 &ndash;
            Intellectual Property) may, at the sole option of NotifyMe, be
            resolved by arbitration administered by Thailand&rsquo;s Arbitration
            Association under its commercial arbitration rules, and judgment on
            the award rendered by the arbitrator(s) may be entered in any court
            having jurisdiction thereof. All arbitration hearings shall be
            conducted in Bangkok, Thailand. Each party shall bear its own costs,
            fees and expenses associated with any arbitration, except that the
            parties agree to split equally the costs and expenses of the
            arbitrator or panel and the conduct of the arbitration itself. In
            the event that NotifyMe does not elect to submit a dispute under
            this Agreement to arbitration, the parties agree to jurisdiction and
            venue for claims or actions arising under this Agreement in
            Thailand&rsquo;s courts located in Bangkok, Thailand and that any
            such disputes will be governed Thai Law as such laws are applied to
            this agreement.
          </span>
        </p>
        <h2 className="mt-16">
          <span className="font-400 text-blue-primary">10. GENERAL</span>
        </h2>
        <p>
          <span className="font-400">
            Customer(s) may not assign any rights or delegate any duties under
            this Agreement and any attempt to do so is void and without effect.
            This Agreement is the parties&rsquo; entire agreement relating to
            the subject matter hereof and supersedes all prior or
            contemporaneous oral or written communications, proposals,
            representations and warranties, and prevails over any conflicting or
            additional terms of any communication between the parties relating
            to its subject matter. No modification to this Agreement will be
            binding unless in writing and signed by an authorized representative
            of each party. Any express waiver or failure to exercise promptly
            any right under this Agreement will not create a continuing waiver
            or any expectation of non‐enforcement. If any provision of this
            Agreement is held to be unenforceable for any reason, such provision
            shall be reformed only to the extent necessary to make it
            enforceable. To the extent that any and all provisions of this
            Agreement shall exclude or limit any statutory liability which,
            according to mandatory provisions of Applicable Law cannot be
            contractually excluded or limited by mutual agreement of the
            parties, then such provision shall be given only such effect, if
            any, as is permitted by the Applicable Law. Neither Customer nor
            NotifyMe will be responsible for any failure or delay in its
            performance under this Agreement, excluding Customer&rsquo;s payment
            obligations, due to causes beyond its reasonable control, including,
            but not limited to, labor disputes, strikes, lockouts, shortages of
            or inability to obtain energy, raw materials or supplies, war,
            terrorism, riot, or natural disaster.
          </span>
        </p>
        <p>
          <br />
          <br />
          <br />
        </p>
        <p>
          <span className="font-400">
            These Terms of Service, together with our Privacy Policy
            (www.ifyoucan.com), collectively, form the agreement (the
            &ldquo;Agreement&rdquo;) between you and us, and govern your access
            to and use of the Services (as defined below) offered by NotifyMe,
            Inc. (&ldquo;NotifyMe&rdquo;, &ldquo;we&rdquo; &ldquo;us&rdquo;,
            &ldquo;our&rdquo;), to you or the entity you represent
            (&ldquo;you&rdquo;).
          </span>
        </p>
        <p>
          <span className="font-400">
            This Agreement commences on the date that you accept it by checking
            a box or clicking on a button (or something similar) when you are
            asked to confirm that you accept this Agreement. Acceptance in any
            of the foregoing manners (or other similar means) indicates that you
            agree to the terms and conditions of this Agreement. If you are
            accepting on behalf of a company, organization, or other entity,
            then (1) &ldquo;you&rdquo; includes you and that entity, and (2) you
            represent and warrant that you are an authorized representative of
            the entity with the authority to bind the entity to this Agreement,
            and that you agree to this Agreement on the entity&rsquo;s behalf.
          </span>
        </p>
        <p>
          <span className="font-400">
            Please read this agreement carefully to ensure that you understand
            each provision. This Agreement contains a mandatory individual
            arbitration and class action/jury trial waiver provision that
            requires the use of arbitration on an individual basis to resolve
            disputes, rather than jury trials or class actions.
          </span>
        </p>
        <h2 className="mt-16">
          <span className="font-400 text-blue-primary">1. DEFINITIONS</span>
        </h2>
        <p>
          <br />
          <span className="font-400">1.2&nbsp; &ldquo;</span>
          <strong>Confidential Information</strong>
          <span className="font-400">
            &rdquo; means all nonpublic information disclosed by us, our
            affiliates, business partners or our or their respective employees,
            contractors or agents that is designated as confidential or that,
            given the nature of the information or circumstances surrounding its
            disclosure, reasonably should be understood to be confidential.
            Confidential Information does not include any information that: (i)
            is or becomes publicly available without breach of this Agreement;
            (ii) can be shown by documentation to have been known to you at the
            time of your receipt from us; (iii) is received from a third party
            who did not acquire or disclose the same by a wrongful or tortious
            act; or (iv) can be shown by documentation to have been
            independently developed by you without reference to the Confidential
            Information.
          </span>
        </p>
        <p>
          <br />
          <span className="font-400">1.3&nbsp; &ldquo;</span>
          <strong>Documentation</strong>
          <span className="font-400">
            &rdquo; means the manuals and online help we provide for use in
            connection with the Service. NotifyMe may update the Documentation
            from time to time at its sole discretion.
          </span>
        </p>
        <p>
          <br />
          <span className="font-400">1.4&nbsp; &ldquo;</span>
          <strong>Electronic Communications</strong>
          <span className="font-400">
            &rdquo; means any transfer, transmission, and/or receipt of text,
            images, data, or other information of any nature to, from, or
            through the Service.
          </span>
        </p>
        <p>
          <br />
          <span className="font-400">1.5&nbsp; &ldquo;</span>
          <strong>NotifyMe Content</strong>
          <span className="font-400">
            &rdquo; means the data transmitted by NotifyMe through the APIs.
          </span>
        </p>
        <p>
          <br />
          <span className="font-400">1.6&nbsp; &ldquo;</span>
          <strong>NotifyMe Technology</strong>
          <span className="font-400">
            &rdquo; means our proprietary software and other technology provided
            via the Services, including any and all enhancements, modifications,
            updates, upgrades, and derivative works to the foregoing.
          </span>
        </p>
        <p>
          <br />
          <span className="font-400">1.7&nbsp; &ldquo;</span>
          <strong>Intellectual Property Rights</strong>
          <span className="font-400">
            &rdquo; means worldwide patents, copyrights, trademarks, service
            marks, trade names, domain name rights, know-how and other trade
            secret rights, and all other intellectual property rights and
            similar forms of protection.
          </span>
        </p>
        <p>
          <br />
          <span className="font-400">1.8&nbsp; &ldquo;</span>
          <strong>Service(s)</strong>
          <span className="font-400">
            &rdquo; means the hosted services provided by us.
          </span>
        </p>
        <p>
          <br />
          <span className="font-400">1.9&nbsp; &ldquo;</span>
          <strong>Site</strong>
          <span className="font-400">
            &rdquo; means our website through which certain Services may be
            accessed or made available to Users.
          </span>
        </p>
        <p>
          <br />
          <span className="font-400">1.10&nbsp; &ldquo;</span>
          <strong>User</strong>
          <span className="font-400">
            &rdquo; means your employees, representatives, consultants,
            contractors, or agents who are authorized to use the Services and
            have been supplied user identifications and passwords by you (or by
            us at your request).
          </span>
        </p>
        <h2 className="mt-16">
          <span className="font-400 text-blue-primary">
            2. PROVISION OF SERVICES AND NotifyMe TECHNOLOGY
          </span>
        </h2>
        <p>
          <br />
          <span className="font-400">2.1 </span>
          <strong>PROVISION OF SERVICES; ACCESS RIGHT</strong>
          <span className="font-400">
            . Subject to your payment of the applicable fees, during the term of
            this Agreement, we will provide you with the Service(s) chosen by
            you. The Services include the standard features and functionality
            applicable to the Services, and any changes, modifications, or
            improvements to such Services, but excluding any new modules that we
            market and sell or provide as separate products or substantial
            improvements to such Services. The Services are purchased on a
            subscription basis. Subject to the terms and conditions of this
            Agreement, NotifyMe grants you a non-exclusive, non-sublicensable,
            non transferable right to: (a) access and use the Services and
            display the NotifyMe Technology; and (b) access and use the APIs to
            receive the NotifyMe Content, in each case solely for your internal
            business purposes. You may have employees, agents, consultants and
            independent contractors access the Services solely in performing
            services on your behalf in accordance with the provisions of this
            Agreement, provided that you bind them to all applicable provisions
            of this Agreement and you remain responsible for their performance
            under this Agreement in all respects. No implied licenses are
            granted hereunder; we reserve all rights not expressly granted.
          </span>
        </p>
        <p>
          <br />
          <span className="font-400">2.2 </span>
          <strong>INDIVIDUAL FEATURES AND SERVICES</strong>
          <span className="font-400">
            . We agree to make certain Services available to you as agreed upon
            between us. Some of these Services may be made available for no
            charge, and some may be made available for a fee as described in
            further detail below. Our Services may be varied, updated, replaced,
            removed, supplemented or added to by us at any time in our sole
            discretion. We will notify you of a change to the Services in
            advance only if the change does not preserve, extend, or enhance the
            features or functionality of the Services. If we notify you of a
            change as required in this Section and you do not wish to use the
            Services after notification of the change, you may within thirty
            (30) days of notification either provide us with written notice of
            termination of this Agreement, or reject the change by written
            notice to us. If you reject a change, we may terminate this
            Agreement within sixty (60) days after your written notice of
            rejection. If you provide no written notice to us within the thirty
            (30) day period, you will be deemed to have accepted the change, and
            this Agreement will continue in full force and effect. Upon
            termination, your sole and exclusive remedy and our sole and
            exclusive liability is a refund of any prepaid and unused fees from
            the effective Services termination date. Nothing in this Section
            requires us to continue to provide any portion of the Services if it
            would result in a violation of the rights of any third party or any
            applicable law.
          </span>
        </p>
        <p>
          <br />
          <span className="font-400">2.3 </span>
          <strong>TECHNICAL SUPPORT</strong>
          <span className="font-400">
            . We will provide such resources and utilize such employees and/or
            consultants as we deem necessary to perform any implementation,
            training, and/or any technical support services relating to the
            Services. The manner and methods we use to perform technical support
            are subject to our sole discretion, although technical support is
            provided principally via email at
          </span>
          <span className="font-400"> EMAIL. </span>
          <span className="font-400">
            You agree to cooperate with us in our efforts to provide the
            technical support. We will use commercially reasonable efforts to
            meet the schedules we commit to in writing, and you agree to
            cooperate in good faith to allow us to complete the services in a
            timely manner.
          </span>
        </p>
        <p>
          <br />
          <span className="font-400">2.4 </span>
          <strong>FEEDBACK</strong>
          <span className="font-400">
            . If you provide us with any suggestions, comments or other feedback
            pertaining to the Services, Site, or NotifyMe Technology
            (collectively, &ldquo;Feedback&rdquo;), such Feedback is and will be
            given entirely voluntarily. We will be free to use, disclose,
            reproduce, license or otherwise distribute and exploit the Feedback
            provided to it as we see fit, entirely without obligation or
            restriction of any kind on account of intellectual property rights
            or otherwise.
          </span>
        </p>
        <p>
          <span className="font-400">
            We are and will remain the sole and exclusive owner of all
            proprietary rights, including all Intellectual Property Rights, in
            and to (a) the APIs,NotifyMe Content, Services, Site, and NotifyMe
            Technology, including any modifications or improvements thereto; and
            (b) any inventions, works of authorship or information that is
            authored, conceived, reduced to practice, invented or otherwise
            developed in the course of performing any services hereunder. You
            acknowledge that our name, our logo, and the product names
            associated with the Services are our trademarks (or those of our
            suppliers or licensors), and no license to such marks is granted
            herein. No ownership of any of the foregoing or any intellectual
            property rights therein is transferred or granted to you except for
            the limited access rights expressly granted herein.
          </span>
        </p>
        <p>
          <br />
          <span className="font-400">2.5 </span>
          <strong>OWNERSHIP</strong>
          <span className="font-400">
            . We are and will remain the sole and exclusive owner of all
            proprietary rights, including all Intellectual Property Rights, in
            and to (a) the APIs, NotifyMe Content, Services, Site, and NotifyMe
            Technology, including any modifications or improvements thereto; and
            (b) any inventions, works of authorship or information that is
            authored, conceived, reduced to practice, invented or otherwise
            developed in the course of performing any services hereunder. You
            acknowledge that our name, our logo, and the product names
            associated with the Services are our trademarks (or those of our
            suppliers or licensors), and no license to such marks is granted
            herein. No ownership of any of the foregoing or any intellectual
            property rights therein is transferred or granted to you except for
            the limited access rights expressly granted herein.
          </span>
        </p>
        <p>
          <br />
          <span className="font-400">2.6 </span>
          <strong>MOBILE SOFTWARE.</strong>
        </p>
        <p>
          <br />
          <strong>(a)</strong>
          <span className="font-400">
            {' '}
            From time to time, we may make available software to access the
            Service via a mobile device (&ldquo;
          </span>
          <strong>Mobile Software</strong>
          <span className="font-400">
            &rdquo;). To use the Mobile Software you must have a mobile device
            that is compatible with the Mobile Software. We do not warrant that
            the Mobile Software will be compatible with your mobile device. You
            agree that you are solely responsible for any mobile data usage or
            other similar charges incurred by you in connection with the Mobile
            Software. Subject to the terms and conditions of this Agreement,
            NotifyMe grants you a non-exclusive, non-transferable, revocable
            license to use a compiled code copy of the Mobile Software for one
            (1) NotifyMe account on one (1) mobile device owned or leased solely
            by you and in accordance with the features made available to you
            (unless NotifyMe expressly allows otherwise). You may not: (i)
            modify, disassemble, decompile or reverse engineer the Mobile
            Software, except to the extent that such restriction is expressly
            prohibited by law; (ii) rent, lease, loan, resell, sublicense,
            distribute or otherwise transfer the Mobile Software to any third
            party or use the Mobile Software to provide time sharing or similar
            services for any third party; (iii) make any copies of the Mobile
            Software; (iv) remove, circumvent, disable, damage or otherwise
            interfere with security-related features of the Mobile Software,
            features that prevent or restrict use or copying of any content
            accessible through the Mobile Software, or features that enforce
            limitations on use of the Mobile Software; or (v) delete the
            copyright and other proprietary rights notices on the Mobile
            Software.
          </span>
        </p>
        <p>
          <span className="font-400">
            You acknowledge that NotifyMe may from time to time issue upgraded
            versions of the Mobile Software, and may automatically
            electronically upgrade the version of the Mobile Software that you
            are using on your mobile device. You consent to such automatic
            upgrading on your mobile device, and agree that the terms and
            conditions of this Agreement will apply to all such upgrades. Any
            third-party code that may be incorporated in the Mobile Software is
            covered by the applicable open source or third-party license EULA,
            if any, authorizing use of such code. The foregoing license grant is
            not a sale of the Mobile Software or any copy thereof, and NotifyMe
            or its third-party partners or suppliers retain all right, title,
            and interest in the Mobile Software (and any copy thereof). Any
            attempt by you to transfer any of the rights, duties or obligations
            hereunder, except as expressly provided for in this Agreement, is
            void.
          </span>
        </p>
        <p>
          <span className="font-400">
            If the Mobile Software is being acquired on behalf of the Government
            of Thailand, then the following provision applies. The Mobile
            Software will be deemed to be &ldquo;commercial computer
            software&rdquo; and &ldquo;commercial computer software
            documentation,&rdquo; respectively, pursuant to DFAR Section
            227.7202 and FAR Section 12.212, as applicable. Any use,
            reproduction, release, performance, display or disclosure of the
            Service and any accompanying documentation by the Thai Government
            will be governed solely by these Terms of Service and is prohibited
            except to the extent expressly permitted by these Terms of Service.
            The Mobile Software originates in Thailand, and is subject to Thai
            export laws and regulations. The Mobile Software may not be exported
            or re-exported to certain countries or those persons or entities
            prohibited from receiving exports from Thailand. In addition, the
            Mobile Software may be subject to the import and export laws of
            other countries. You agree to comply with all Thai and foreign laws
            related to use of the Mobile Software and the Service.
          </span>
        </p>
        <p>
          <br />
          <strong>(b)</strong>
          <span className="font-400">
            {' '}
            The following applies to any Mobile Software you acquire from
            Apple&rsquo;s App Store (&ldquo;
          </span>
          <strong>App Store-Sourced Software</strong>
          <span className="font-400">
            &rdquo;): You acknowledge and agree that this Agreement is solely
            between you and NotifyMe, not Apple, and that Apple has no
            responsibility for the App Store-Sourced Software or content
            thereof. Your use of the App Store-Sourced Software must comply with
            the App Store Terms of Service. You acknowledge that Apple has no
            obligation whatsoever to furnish any maintenance and support
            services with respect to the App Store-Sourced Software. In the
            event of any failure of the App Store-Sourced Software to conform to
            any applicable warranty, you may notify Apple, and Apple will refund
            the purchase price for the App Store-Sourced Software to you; to the
            maximum extent permitted by applicable law, Apple will have no other
            warranty obligation whatsoever with respect to the App Store-Sourced
            Software, and any other claims, losses, liabilities, damages, costs
            or expenses attributable to any failure to conform to any warranty
            will be solely governed by this Agreement and any law applicable to
            NotifyMe as provider of the software. You acknowledge that Apple is
            not responsible for addressing any claims of you or any third party
            relating to the App Store-Sourced Software or your possession and/or
            use of the App Store-Sourced Software, including, but not limited
            to: (i) product liability claims; (ii) any claim that the App
            Store-Sourced Software fails to conform to any applicable legal or
            regulatory requirement; and (iii) claims arising under consumer
            protection or similar legislation; and all such claims are governed
            solely by this Agreement and any law applicable to NotifyMe as
            provider of the software.
          </span>
        </p>
        <p>
          <span className="font-400">
            You acknowledge that, in the event of any third-party claim that the
            App Store-Sourced Software or your possession and use of that App
            Store-Sourced Software infringes that third party&rsquo;s
            intellectual property rights, NotifyMe, not Apple, will be solely
            responsible for the investigation, defense, settlement and discharge
            of any such intellectual property infringement claim to the extent
            required by this Agreement. You and NotifyMe acknowledge and agree
            that Apple, and Apple&rsquo;s subsidiaries, are third-party
            beneficiaries of this Agreement as relates to your license of the
            App Store-Sourced Software, and that, upon your acceptance of the
            terms and conditions of this Agreement, Apple will have the right
            (and will be deemed to have accepted the right) to enforce this
            Agreement as relates to your license of the App Store-Sourced
            Software against you as a third-party beneficiary thereof.
          </span>
        </p>
        <p>
          <br />
          <strong>(c) </strong>
          <span className="font-400">
            The following applies to any Mobile Software you acquire from the
            Google Play Store (&ldquo;
          </span>
          <strong>Google-Sourced Software</strong>
          <span className="font-400">
            &rdquo;): (i) you acknowledge that the Agreement is between you and
            NotifyMe only, and not with Google, Inc. (&ldquo;Google&rdquo;);
            (ii) your use of Google-Sourced Software must comply with
            Google&rsquo;s then-current Google Play Store Terms of Service;
            (iii) Google is only a provider of the Google Play Store where you
            obtained the Google-Sourced Software; (iv) NotifyMe, and not Google,
            is solely responsible for its Google-Sourced Software; (v) Google
            has no obligation or liability to you with respect to Google-Sourced
            Software or the Agreement; and (vi) you acknowledge and agree that
            Google is a third-party beneficiary to the Agreement as it relates
            to Estimote&rsquo;s Google-Sourced Software.
          </span>
        </p>
        <h2 className="mt-16">
          <span className="font-400 text-blue-primary">
            3. CUSTOMER ACCOUNTS
          </span>
        </h2>
        <p>
          <br />
          <span className="font-400">3.1 </span>
          <strong>ACCESS AND USE OF THE SERVICES.</strong>
          <span className="font-400">
            {' '}
            You are responsible for the connection to the Site and Services,
            including the Internet connection. We are not responsible for any
            inability to meet our obligations under this Agreement to the extent
            that such inability results from or relates to your connection to
            the Site and Services. You may use the Services and NotifyMe
            Technology only in accordance with this Agreement and the
            Documentation.
          </span>
        </p>
        <p>
          <br />
          <span className="font-400">3.2 </span>
          <strong>USE RESTRICTIONS.</strong>
          <span className="font-400">
            {' '}
            Without limiting the generality of the foregoing, you may not
            license, sell, distribute, rent, lease, lend, transfer, outsource,
            or otherwise provide access to any Services or utilize any Services
            for the benefit of any third party. Further, when using the Services
            and NotifyMe Technology, you may not, and you will ensure that Users
            do not: (a) decompile, decipher, disassemble, translate, modify,
            prepare derivative works of, reverse engineer or otherwise attempt
            to access the source code of the Services, Site, or NotifyMe
            Technology, except as permitted by applicable law; (b) infringe the
            intellectual property or other proprietary rights of any third
            party; (c) interfere with or disrupt the NotifyMe Technology,
            systems we use to host the Site or Services, or other equipment or
            networks connected to the Site or Services, or disobey any
            requirements, procedures, policies or regulations of networks
            connected to the Site or the Services made known to you; (d) use the
            Services, Site, or NotifyMe Technology in the operation of a service
            bureau or time-sharing service; (e) circumvent the user
            authentication or security of the Services, Site, or NotifyMe
            Technology or any host, network, or account related thereto, attempt
            to gain unauthorized access to a network, computer, software
            application, or any part thereof, misrepresent the source, identity,
            or content of information transmitted via the Services, including by
            forging network packages or e-mail headers, or use or access the
            Services in a manner intended to avoid the payment of fees; (f) make
            any use of the Services, Site, or NotifyMe Technology that violates
            any applicable Thai, international or foreign law; (g) fail to use
            commercially reasonable efforts to prevent the unauthorized license,
            sale, transfer, lease, transmission, distribution or other
            disclosure of the Services, Site, or NotifyMe Technology, (h) allow
            any third party to use any user identification(s), code(s),
            password(s), procedure(s) and user keys issued to, or selected by,
            you for access to the Services, Site, or NotifyMe Technology; (i)
            cache, record, pre-fetch, or otherwise store any portion of the
            NotifyMe Content, or attempt or provide a means to execute any
            &ldquo;bulk download&rdquo; operations; (j) modify the NotifyMe
            Content, or use it to create a product that competes in any way with
            NotifyMe or any of NotifyMe&rsquo;s products, including but not
            limited to the Services; (k) use the APIs on behalf of any
            third-party; (l) modify, rate, rank, review, vote or comment on, or
            otherwise respond to the NotifyMe Content; or (m) copy, rent, lease,
            transfer, assign, sublicense, disassemble, reverse engineer or
            decompile (except to the limited extent expressly authorized under
            applicable statutory law), modify or alter any part of the APIs. In
            addition, you may not: (1) use the Services, Site, or NotifyMe
            Technology in any manner that we reasonably believe is abusive or
            contrary to applicable law; (2) remove, obscure, or alter our
            copyright notices, trademarks, or other proprietary rights notices
            on any Services, Site, or NotifyMe Technology; or (3) during the
            term of this Agreement, assert or authorize, assist, or encourage
            any third party to assert, against us or any of our affiliates, any
            patent infringement or other intellectual property infringement or
            misappropriation claim regarding any component of the Services,
            Site, or NotifyMe Technology.
          </span>
        </p>
        <p>
          <br />
          <span className="font-400">3.3 </span>
          <strong>ACCOUNTS.</strong>
          <span className="font-400">
            {' '}
            You must create an account to access and use the Services. You agree
            to provide accurate and complete information when signing up for an
            account. You are solely responsible for all activities that take
            place on or through your account, including the acts and omissions
            of your Users/Subscribers. You will, and you will require Users to,
            take appropriate security precautions including ensuring
            appropriately complex passwords, keeping passwords confidential, and
            regularly changing passwords. You will, and you will require Users
            to, comply with our security guidelines and procedures made known to
            you through the Services or otherwise. If you learn of a third party
            having obtained knowledge of a password without authorization, you
            will inform us of such unauthorized access without undue delay and
            promptly change the password. Rights of any User to utilize any
            Service cannot be shared or used by more than one (1) individual
            unless we expressly provide otherwise in writing. In addition, a
            User&rsquo;s access information and privileges may not be
            transferred from one individual to another unless the original User
            no longer requires and is no longer permitted access to the
            applicable Services, as a result of which that individual is no
            longer a User. We are not responsible for any unauthorized access to
            your account, including any unauthorized use of the Services, and
            you agree to notify us promptly of any unauthorized use of your
            account. You may use the Services and register for an account with
            us only if you can form a binding contract with us, and only in
            compliance with this Agreement and all applicable local, state,
            national, and international laws, rules and regulations. Any use or
            access to the Services by anyone under 18 is strictly prohibited and
            in violation of this Agreement. You may terminate your account at
            any time as set forth in Section 7.
          </span>
        </p>
        <p>
          <br />
          <span className="font-400">3.4 </span>
          <strong>RIGHT TO MONITOR AND ENFORCE.</strong>
          <span className="font-400">
            {' '}
            NotifyMe may, but has no obligation to, monitor any content or
            traffic on the Services, for the purposes of ensuring that the
            Services are being used in accordance with this Agreement. We may,
            without notice to you: Intercept, block, or remove any content or
            traffic that we believe violates this Agreement, or applicable laws;
            and report to the appropriate authorities any conduct by you that we
            believe violates applicable laws, which may include disclosure of
            your relevant personal data, or usage history on the Services.
          </span>
        </p>
        <p>
          <br />
          <span className="font-400">3.5 </span>
          <strong>ACCOUNT SUSPENSION.</strong>
          <span className="font-400">
            {' '}
            We may suspend your account and access to the Services, Site, or
            NotifyMe Technology without liability if: (a) we have reason to
            believe that the Services, Site, or NotifyMe Technology have, are
            being, or will be used in violation of this Agreement; (b) you fail
            to make a payment to us when due; (c) we reasonably believe that
            your Services, Site, or NotifyMe Technology are being accessed or
            used by third parties without your authorization; (d) we are
            required to do so by law; or (e) you have ceased to operate in the
            ordinary course, made an assignment for the benefit of creditors, or
            become the subject of any bankruptcy, reorganization, liquidation,
            dissolution, or similar proceeding. If your account remains
            suspended for a period of thirty (30) days or more, we may terminate
            your account without notice to you as set forth in Section 7
            (&ldquo;Term and Termination&rdquo;). If your account is suspended
            for any reason, you remain responsible for all fees accrued through
            the date of suspension. In addition, if your account is suspended
            due to clause (ii), you remain responsible for all contracted fees,
            notwithstanding such suspension.
          </span>
        </p>
        <h2 className="mt-16">
          <span className="font-400  text-blue-primary">
            4. CUSTOMER DATA: RIGHTS AND RESPONSIBILITIES
          </span>
        </h2>
        <p>
          <br />
          <span className="font-400">4.1 </span>
          <strong>CUSTOMER DATA DEFINED.</strong>
          <span className="font-400">
            {' '}
            We do not collect any personal information about you, your Users, or
            your customers except as necessary in the course of providing the
            Services to you. However, certain NotifyMe products do collect
            information about your customers and their interactions with such
            products (&ldquo;Customer Data&rdquo;). Subject to the provisions of
            this Section 4, you retain ownership of and control over Customer
            Data we collect through the provision of our Service to you, and we
            do not share such Customer Data, or use such Customer Data for the
            benefit of other NotifyMe customers..
          </span>
        </p>
        <p>
          <br />
          <span className="font-400">4.2 </span>
          <strong>CUSTOMER DATA LICENSE GRANT.</strong>
          <span className="font-400">
            {' '}
            By permitting us to collect your Customer Data or providing your
            Customer Data to us, you hereby expressly grant, and you represent
            and warrant that you have all rights necessary to grant, to NotifyMe
            a nonexclusive, royalty-free, worldwide license during the term of
            the Agreement to use, transmit, distribute, modify, reproduce,
            display, and store the Customer Data for the purposes of: (i)
            providing the Services as contemplated herein; and (ii) enforcing
            NotifyMe&rsquo;s rights under the Agreement.
          </span>
        </p>
        <p>
          <br />
          <span className="font-400">4.3 </span>
          <strong>YOUR RESPONSIBILITIES FOR YOUR CUSTOMER DATA.</strong>
          <span className="font-400">
            {' '}
            In connection with your Customer Data, as of the date you accepted
            this Agreement and throughout the term of this Agreement, you
            represent, warrant and agree that:
          </span>
        </p>
        <p>
          <strong>(a) </strong>
          <span className="font-400">
            you have obtained the Customer Data lawfully, and the Customer Data
            does not and will not violate any applicable laws or a third
            party&rsquo;s proprietary, privacy or intellectual property rights;
          </span>
        </p>
        <p>
          <strong>(b) </strong>
          <span className="font-400">
            at all times, Customer Data has and will be collected by you in
            accordance with your publicly posted privacy policy that permits you
            to share, collect, use and disclose such Customer Data as
            contemplated under this Agreement, and if required by applicable
            law, pursuant to consents obtained by you to do each of the
            foregoing. For clarity and without limitation, customer is
            responsible for the content and placement of consumer-facing
            disclosure regarding the collection and use of Customer Data;
          </span>
        </p>
        <p>
          <strong>(c) </strong>
          <span className="font-400">
            we may exercise the rights to your Customer Data granted under this
            Agreement without liability or cost to any third party; and
          </span>
        </p>
        <p>
          <strong>(d) </strong>
          <span className="font-400">
            the Customer Data complies with the terms of this Agreement.
          </span>
        </p>
        <p>
          <br />
          <span className="font-400">4.4 </span>
          <strong>CUSTOMER DATA USE</strong>
          <span className="font-400">
            . Notwithstanding anything to the contrary herein, you agree that
            NotifyMe may collect, analyze, and use Customer Data and data
            derived from Customer Data, including de-identified, aggregated or
            anonymized Customer Data, for purposes of operating, analyzing,
            improving, or marketing the Services. If NotifyMe shares or publicly
            discloses information (e.g., in marketing materials, or in
            application development) that is derived from Customer Data, such
            data will be aggregated or anonymized to reasonably avoid
            identification of a specific customer, user or individual. You
            further agree that NotifyMe will have the right, both during and
            after the Term of this Agreement, to use, store, transmit,
            distribute, modify, copy, display, sublicense, and create derivative
            works of the anonymized, aggregated data.
          </span>
        </p>
        <p>
          <br />
          <span className="font-400">4.5 </span>
          <strong>SERVICE USAGE DATA</strong>
          <span className="font-400">
            . For the sole purpose of providing and improving our Services, we
            may collect and use data relating to the usage of the Services,
            including without limitation monitoring and analyzing usage and
            traffic patterns of our websites and Services. This usage data is:
            (a) not Customer Data; (b) does not include any personal information
            about you, your Users, or your customers; and (c) is owned by
            NotifyMe.
          </span>
        </p>
        <h2 className="mt-16">
          <span className="font-400  text-blue-primary">6. SECURITY</span>
        </h2>
        <p>
          <br />
          <span className="font-400">6.1 </span>
          <strong>YOUR PRECAUTIONS</strong>
          <span className="font-400">
            . You will take reasonable security precautions including ensuring
            appropriately complex passwords, keeping your passwords confidential
            and regularly changing your passwords. You will be solely
            responsible for all activity which takes place on or through your
            account.
          </span>
        </p>
        <p>
          <br />
          <span className="font-400">6.2 </span>
          <strong>OUR SAFEGUARDS</strong>
          <span className="font-400">
            . We have implemented commercially reasonable and legally compliant
            technical, administrative, and organizational measures designed to
            mitigate against accidental loss and from unauthorized access, use,
            alteration or disclosure of the data and other information you
            provide us in connection with your use of the Services (if any).
            However, you acknowledge and agree that we cannot guarantee that
            unauthorized third parties will not be able to defeat those
            measures. You acknowledge that it is not feasible for us to
            accommodate conflicting data security requirements from multiple
            customers; accordingly, failure to accommodate your specific data
            security requests or requirements will not be deemed a breach of
            this Agreement. For the avoidance of doubt, we do not warrant that
            your use of the Services is risk-free. We do not provide
            representations, warranties, or assurances against interception or
            access and, provided that we comply with the other provisions of
            this Section, we will not be responsible for any theft, illegal
            activity or other unauthorized acts resulting in loss of or damage
            to you or any User, or your or their computer, data or other
            property in connection with use of the Services.
          </span>
        </p>
        <p>
          <br />
          <span className="font-400">6.3 </span>
          <strong>OUR PRIVACY POLICY</strong>
          <span className="font-400">
            . By accessing or using the Service, you agree to the collection,
            use, and disclosure of certain personally identifiable information,
            such as your name and address, in accordance with the{' '}
          </span>
          <a
            target="_blank"
            href="https://estimote.com/legal/privacy-policy.html"
            rel="noopener noreferrer"
          >
            <span className="font-400">Privacy Policy</span>
          </a>
          <span className="font-400">
            , including having this information collected, used, transferred to
            and processed in Thailand.
          </span>
        </p>
        <h2 className="mt-16">
          <span className="font-400  text-blue-primary">
            7. TERM AND TERMINATION
          </span>
        </h2>
        <p>
          <br />
          <span className="font-400">7.1 </span>
          <strong>TERM</strong>
          <span className="font-400">
            . This Agreement will commence on the day it is accepted by you, and
            will continue until terminated in accordance with the terms of this
            Agreement.
          </span>
        </p>
        <p>
          <br />
          <span className="font-400">7.2 </span>
          <strong>TERMINATION</strong>
          <span className="font-400">.</span>
        </p>
        <p>
          <br />
          <strong>(a) By Either Party</strong>
          <span className="font-400">
            . Either party may terminate this Agreement if the other party
            breaches any of the provisions of this Agreement, and does not cure
            such breach within thirty (30) days of receiving written notice of
            such breach, except that for a breach of Section 3.2 (&ldquo;Use
            Restrictions&rdquo;) or 8 (&ldquo;Confidentiality&rdquo;), there
            will be no cure period.
          </span>
        </p>
        <p>
          <br />
          <strong>(b) By Us</strong>
          <span className="font-400">
            . We may terminate your account immediately upon written notice if
            you breach Section 3.2, or if your account has been suspended for a
            period of thirty (30) days or more as set forth in Section 3.5. We
            may also suspend or terminate your account upon a determination by
            us that continued use of the Services may result in harm to the
            Services (including the Site, NotifyMe Technology, and/or systems
            used to provide the Services) or our other customers, or result in a
            violation of applicable law, regulation, legal obligation or legal
            rights of another. In such an event, in addition to any other
            remedies available at law or in equity, we will have the right
            immediately, in our sole discretion, to deactivate your user name(s)
            and password(s), until such time as the issue is resolved or this
            Agreement is terminated. In addition, we may terminate this
            Agreement for convenience by providing you with thirty (30) days
            advance notice.
          </span>
        </p>
        <p>
          <br />
          <strong>(c) Effect of Termination</strong>
          <span className="font-400">
            . If this Agreement is terminated for any reason, then (i) subject
            to clause (iii) below, your access to the Services will terminate,
            and you will stop using the Services immediately, (ii) all
            contracted fees will be due and payable, and (iii) you will destroy
            or return the Confidential Information, if requested by us, certify
            such destruction or return. Notwithstanding any termination hereof,
            the provisions of Sections 2.7, 3.2, 4, 5, 6, 7.2(c), 8, 9, 10, 12,
            13, and 14 will survive any expiration or early termination of this
            Agreement for any reason.
          </span>
        </p>
        <h2 className="mt-16">
          <span className="font-400  text-blue-primary">
            8. CONFIDENTIALITY
          </span>
        </h2>
        <p>
          <span className="font-400">
            You will use at least the same degree of care that you use for your
            own information of similar nature but no less than reasonable care,
            to protect the Confidential Information from misuse or unauthorized
            disclosure. You will use the Confidential Information only for
            purposes of performing under this Agreement, and not disclose the
            Confidential Information without our prior written consent.
          </span>
        </p>
        <h2 className="mt-16">
          <span className="font-400  text-blue-primary">
            9. DISCLAIMERS; NO WARRANTIES
          </span>
        </h2>
        <p>
          <br />
          <span className="font-400">9.1 </span>
          <strong>NO WARRANTIES</strong>
          <span className="font-400">
            . Except as expressly provided herein, the APIs, NotifyMe Content,
            Services, Site, and NotifyMe Technology, are provided to you on an
            &ldquo;as is&rdquo; and &ldquo;as available&rdquo; basis without
            warranties of any kind either express or implied. To the fullest
            extent permissible pursuant to applicable law, we and our suppliers,
            licensors, and partners disclaim all warranties, statutory, express
            or implied, including, but not limited to, the implied warranties of
            merchantability, fitness for a particular purpose, title, and
            non-infringement of proprietary rights, with regard to the APIs,
            NotifyMe Content, Services, Site, and NotifyMe Technology. We do not
            represent or warrant that any Services or data provided by us will
            be accurate, complete, error-free, or backwards-compatible with
            prior versions, or that such Services or data will meet your
            specific requirements or expectations.
          </span>
        </p>
        <p>
          <br />
          <span className="font-400">9.2 </span>
          <strong>NO RESPONSIBILITY FOR DATA LOSS</strong>
          <span className="font-400">
            . Notwithstanding anything to the contrary stated herein, we will
            not be responsible or liable for the deletion, correction,
            destruction, damage, loss, or failure to store or maintain any data
            you provide us, or any other data or information.
          </span>
        </p>
        <p>
          <br />
          <span className="font-400">9.3 </span>
          <strong>NO RESPONSIBILITY FOR ELECTRONIC COMMUNICATIONS</strong>
          <span className="font-400">
            . The APIs and Services may be subject to limitations, delays, and
            other problems inherent in the use of the internet, personal
            computers, and electronic communications. We are not responsible for
            any delays, delivery failures, or other damage resulting from such
            problems. Without limiting the generality of the foregoing, you
            understand that the technical processing and transmission of
            electronic communications is essential to your use of the service.
            You consent to our interception and storage of electronic
            communications and/or data you provide us, and understand that such
            interception and storage will involve transmission over the internet
            and over various networks that may not be owned, operated, or
            controlled by us. You acknowledge that changes to such data may
            occur (including encryption and compression) in order to conform and
            adapt such data to the technical requirements of connecting networks
            and/or devices. You acknowledge and understand that, when
            communicated across the internet, network facilities, or other
            electronic means, electronic communications may be accessed by
            unauthorized parties.
          </span>
        </p>
        <p>
          <br />
          <span className="font-400">9.4 </span>
          <strong>HIGH RISK USES OF THE SERVICES PROHIBITED</strong>
          <span className="font-400">
            . The Services are not designed or intended for uses where the
            failure of the Services could result in death, bodily injury, or
            environmental damage. You may not use the Services for any such
            purposes.
          </span>
        </p>
        <h2 className="mt-16">
          <span className="font-400  text-blue-primary">
            10. LIMITATIONS ON LIABILITY.
          </span>
        </h2>
        <p>
          <br />
          <span className="font-400">10.1 </span>
          <strong>LIMITATION ON INDIRECT LIABILITY</strong>
          <span className="font-400">
            . Subject to section 10.3 (&ldquo;exclusions&rdquo;), under no
            circumstances, including, but not limited to negligence, will either
            you or we (or our affiliates, contractors, employees, agents, or
            third-party partners, licensors, or suppliers) be liable for any
            special, indirect, incidental, consequential, punitive, reliance, or
            exemplary damages (including without limitation losses or liability
            resulting from loss of data, loss of revenue, anticipated profits,
            or loss of business opportunity) that result from your use or your
            inability to use the Services, NotifyMe Technology, Site, or any
            other products or Services provided in connection with this
            Agreement, , even if you or we (or an authorized representative of
            ours) has been advised of the possibility of such damages.
          </span>
        </p>
        <p>
          <br />
          <span className="font-400">10.2 </span>
          <strong>LIMITATION ON DAMAGES</strong>
          <span className="font-400">
            . Subject to section 10.3 (&ldquo;exclusions&rdquo;), in no event
            will your or our (or our affiliates&rsquo;, contractors&rsquo;,
            employees&rsquo;, agents&rsquo;, or third-party partners&rsquo;,
            licensors&rsquo;, or suppliers&rsquo;) total cumulative liability to
            the other party for all damages, losses, and causes of action
            arising out of or relating to this Agreement or your use of the
            Services, Site, or any other products or Services provided in
            connection with this Agreement, including without limitation your
            interactions with other users, (whether in contract, tort including
            negligence, warranty, or otherwise) exceed the amount paid or
            payable by you, if any, for accessing the Services during the twelve
            (12) months immediately preceding the day the act or omission
            occurred that gave rise to your claim or thirty thousand Thai Baht
            (THB 30,000), whichever is greater.
          </span>
        </p>
        <p>
          <br />
          <span className="font-400">10.3 </span>
          <strong>EXCLUSIONS</strong>
          <span className="font-400">
            . The exclusions and limitations set forth in sections 10.1 and 10.2
            above do not apply to a breach of section 2.5, 2.7, 3.2, 3.3, 4.3,
            8, or to either party&rsquo;s indemnification obligations. In
            addition, the limitations set forth in section 10.2 will also not
            apply to direct damages to the extent arising out of a party&rsquo;s
            gross negligence, intentional misconduct, or fraud.
          </span>
        </p>
        <p>
          <br />
          <span className="font-400">10.4 </span>
          <strong>LIMITATIONS ARE A BASIS OF THE BARGAIN</strong>
          <span className="font-400">
            . You acknowledge and agree that we have offered our Services, and
            entered into this Agreement, in reliance upon the disclaimers of
            warranty and the limitations of liability set forth herein, that the
            disclaimers of warranty and the limitations of liability set forth
            herein reflect a reasonable and fair allocation of risk between you
            and us (including the risk that a contract remedy may fail of its
            essential purpose and cause consequential loss), and that the
            disclaimers of warranty and the limitations of liability set forth
            herein form an essential basis of the bargain between you and us,
            without which the economic terms of this Agreement would be
            different.
          </span>
        </p>
        <h2 className="mt-16">
          <span className="font-400  text-blue-primary">
            11. SERVICES LOCATION; EXPORT RESTRICTIONS.
          </span>
        </h2>
        <p>
          <span className="font-400">
            The Services are controlled and operated from our facilities in
            Thailand. We make no representations that the Services are
            appropriate or available for use in other locations. Those who
            access or use the Services from other jurisdictions do so at their
            own volition and are entirely responsible for compliance with local
            law, including but not limited to export and import regulations. You
            may not use the Services if you are a resident of a country
            embargoed by Thailand, or are a foreign person or entity blocked or
            denied by the Thai government. By using the Services, on behalf of
            yourself and all Users, you are consenting to have your information
            transferred to and processed in Thailand.
          </span>
        </p>
        <h2 className="mt-16">
          <span className="font-400  text-blue-primary">
            12. INDEMNIFICATION.
          </span>
        </h2>
        <p>
          <span className="font-400">
            To the fullest extent permissible under applicable law, you agree to
            indemnify, defend and hold harmless us and our affiliates,
            contractors, employees, agents, and third-party partners, licensors
            and suppliers from and against all claims, liabilities, causes of
            action, damages and costs (including settlement costs and reasonable
            attorneys&rsquo; fees) arising out of third party claims, suits,
            actions or proceedings relating to: (a) use of or access to the
            Services and any related data by you or any of your agents,
            employees, contractors; by anyone using your unique username,
            password or other appropriate security code; or by end users of your
            products or services; (b) breach of any provision of this Agreement;
            (c) your Customer Data; or (d) violation of any law, rule or
            regulation of Thailand or any other country by you or any of your
            agents, employees, contractors, or by end users of your products or
            services. We will use reasonable efforts to notify you of any such
            claims, actions, or proceedings upon becoming aware of the same. We
            will notify you in a reasonably prompt manner of claims, suits,
            actions, or proceedings for which we are seeking the above
            indemnification, provided that failure to so notify will not relieve
            you of your obligations except to the extent your ability to defend
            the claim, suit, action or proceeding is prejudiced by the delay.
            You may use counsel of your choosing (subject to our written
            approval). Any settlement requiring us to admit liability or to pay
            any money will require our prior written consent; and we may join in
            the defense and participate in any settlement discussions with our
            own counsel at our own expense.
          </span>
        </p>
        <p>&nbsp;</p>
      </DialogContent>
    </ResponsiveDialog>
  )
}

export default PlanBillingTermAndConditionBeacon
